export default __webpack_public_path__ + "static/media/material.55f8de08.svg";